import * as React from 'react';
import Table from "@mui/material/Table";
import { activityItem } from "../../types/types";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { fields, mapFieldToText } from "../../lang/constants";
import { toLocaleUTCDateString } from '../../actions/folderViewActions';
// import IconButton from '@mui/material/IconButton/IconButton';
import SyncIcon from '@mui/icons-material/Sync';
import { currPathValue } from '../../types/enums';

interface MyActivitiesProps {
    activities: activityItem[];
    handleGetWfActivity: (wfRno:number, actRno:number, title:string) => void;
    refresh: (value: currPathValue)=> void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const MyActivitiesList = (props:MyActivitiesProps) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
          setValue(newValue);
        };

  const openTabTitle = `${mapFieldToText(fields.OPEN_ACTIVITIES)} (${props.activities.filter(x=>x.ClosedDate==="0001-01-01T00:00:00").length})`;
  const closedTabTitle = `${mapFieldToText(fields.CLOSED_ACTIVITIES)} (${props.activities.filter(x=>x.ClosedDate!=="0001-01-01T00:00:00").length})`;
  return (
            <Box sx={{ width: '100%' }}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                          <Tabs value={value} onChange={handleChange} aria-label="basic tabs">
                              <Tab label={openTabTitle} {...a11yProps(0)} sx={{flexGrow:1, fontWeight: 'bold'}}/>
                              <Tab label={closedTabTitle} {...a11yProps(1)} sx={{ flexGrow: 1, fontWeight: 'bold' }}/>
                              <Tab icon={<SyncIcon/>} {...a11yProps(1)} onClick={() => {
                                                                                      props.refresh(currPathValue.Activities);
                                                                                    }}/>
                          </Tabs>
                      </Box>
                      <CustomTabPanel value={value} index={0}>
                        <Table>
                          {props.activities.filter(x=>x.ClosedDate==="0001-01-01T00:00:00")
                              .sort((a, b) => (new Date(b.ReceivedDate)).getTime() - (new Date(a.ReceivedDate)).getTime()).map((item:activityItem) => { 
                            return <TableRow>
                                  <TableCell onClick={()=> props.handleGetWfActivity(item.WorkflowItem.Id,item.Id, `${item.WorkflowItem.Name} - ${item.ActivityTemplate.Name}`)}>
                                    <Typography variant="h6"><b>{item.WorkflowItem.Name} - {item.ActivityTemplate.Name}</b></Typography>
                                    <Typography>{mapFieldToText(fields.RECEIVED)}: {toLocaleUTCDateString(item.ReceivedDate,true)} {mapFieldToText(fields.DUE)}: {toLocaleUTCDateString(item.DueDate,false)}</Typography>
                                  </TableCell>
                                </TableRow>
                              } 
                            )
                          }
                        </Table>
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={1}>
                        <Table>
                          {props.activities.filter(x=>x.ClosedDate!=="0001-01-01T00:00:00")
                                .sort((a, b) => (new Date(b.ClosedDate)).getTime() - (new Date(a.ClosedDate)).getTime())
                                .map((item:activityItem) => { 
                            return <TableRow>
                                  <TableCell onClick={()=> props.handleGetWfActivity(item.WorkflowItem.Id,item.Id, `${item.WorkflowItem.Name} - ${item.ActivityTemplate.Name}`)}>
                                    <Typography variant="h6"><b>{item.WorkflowItem.Name} - {item.ActivityTemplate.Name}</b></Typography>
                                    <Typography>{mapFieldToText(fields.RECEIVED)}: {toLocaleUTCDateString(item.ReceivedDate,true)} {mapFieldToText(fields.DUE)}: {toLocaleUTCDateString(item.DueDate,false)} {mapFieldToText(fields.ACTIVITY_CLOSED_ON)}: {toLocaleUTCDateString(item.ClosedDate,false)}{item.Decision === "" ? "" : ` ${mapFieldToText(fields.DECISION)} ${item.Decision}`}
                                      </Typography>
                                  </TableCell>
                                </TableRow>
                              } 
                            )
                          }
                        </Table>
                      </CustomTabPanel>
                  </Box>  
    )
}